import FloatingWhats from "../Components/FloatingWhats.jsx";
import Header from "../Components/Header.jsx";
import React, { useState } from "react";
import { Box, Button, Grid2, IconButton, Modal } from "@mui/material";
import BottomBar from "../Components/BottomBar.jsx";
import Footer from "../Components/Footer.jsx";
import styles from "../styles/ProdCel.css"
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Card from "../Components/Card.jsx";

const images = [
    "/images/pdx-1.png",
    "/images/pdx-2.png",
    "/images/pdx-3.png",
];

const ProdCelPDX = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextImage = () => {
        setCurrentIndex((prev) =>
            prev === images.length - 1 ? 0 : prev + 1
        );
    };

    const prevImage = () => {
        setCurrentIndex((prev) =>
            prev === 0 ? images.length - 1 : prev - 1
        );
    };

    return (
        <div className="container">
            <FloatingWhats/>
            <Header/>    
            <div className="content">
                <div className="bannerInterno-container from-top">
                    <div className="bannerInterno-content">
                        <div className="bannerInterno">
                            <h1 className="bannerInterno-title">PDX<br/>Digital</h1>
                            <img className="bannerInterno-img" src="/images/banner-pdx.png" alt="Banner Célula PDX"/>
                        </div>
                    </div>
                </div>
                <div className="caminho">
                    <div className="caminho-content from-left">
                        <a className="caminho-link" href="/">Início</a>
                        <span className="caminho-separador">/</span>
                        <a className="caminho-link" href="/produtos">Produtos</a>
                        <span className="caminho-separador">/</span>
                        <a className="caminho-link" href="/produtos/pesagem-rodoviaria">Pesagem Rodoviária</a>
                        <span className="caminho-separador">/</span>
                        <span className="caminho-atual">PDX</span>
                    </div>
                </div>
                <div className="produto-header">
                    <div className="produto-header-content">
                        <div className="produto-header-left from-left">
                            <div className="produto-header-fotosBox">
                                <img className="produto-header-foto" src={images[currentIndex]} alt="Produto" />
                                <button className="produto-header-btn left" onClick={prevImage}><ChevronLeftIcon sx={{ fontSize: 40 }}/></button>
                                <button className="produto-header-btn right" onClick={nextImage}><ChevronRightIcon sx={{ fontSize: 40 }} /></button>
                            </div>
                        </div>
                        <div className="produto-header-right from-right">
                            <div className="produto-header-infoBox">
                                <div className="produto-header-infoBox1">
                                    <h1 className="produto-header-name from-right">PDX</h1>
                                    <h4 className="produto-header-sku from-right">ID:2077</h4>
                                </div>
                                <div className="produto-header-descricao">
                                    <span className="produto-header-info"><strong>Fabricante:</strong> MettlerToledo</span>
                                    <span className="produto-header-info"><strong>Tipo de Sinal:</strong> Digital</span>
                                    <span className="produto-header-info"><strong>Classe de Proteção:</strong> IP68/69k</span>
                                    <span className="produto-header-info"><strong>Material:</strong> Aço Inoxidável</span>
                                    <span className="produto-header-info"><strong>Capacidade Máxima:</strong> 50 Toneladas</span>
                                    <span className="produto-header-info"><strong>Proteção contra raios:</strong> 80.000 A</span>
                                </div>
                                <div className="produto-header-infoBox3">
                                    <h3 className="produto-header-chamada">
                                        <span style={{color:'#474747'}}>Alguma Dúvida?</span>
                                    </h3>
                                    <a href="https://wa.me/+556599547518"><Button sx={{fontFamily:'Inter', textTransform:'none', width:'100%', height:90, backgroundColor:'#474747', borderRadius:'8px', color:'#fff', fontSize:'20px','&:hover':{backgroundColor:'#7D1115'}}}>Falar com Vendedor</Button></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="downloads">
                    <div className="downloads-content">
                        <h3 className="downloads-title">Arquivos para Download</h3>
                        <div className="downloads-links">
                            <a className="downloads-link" href="https://drive.google.com/drive/folders/1Ss-gFCj7CN8wygPaJ1-qstJR0Pwe_QNp?usp=drive_link" target="_blank" rel="noopener noreferrer"><img src="/images/icons/arquivo.svg" className="download-icon"/>Ficha Técnica</a>
                        </div>
                    </div>
                </div>
                <div className="cel-descricao">
                    <div className="cel-descricao-content">
                        <h2 className="cel-descricao-title">Descrição</h2>
                        <div className="cel-descricao-text">
                            <h3>As células de carga PDX® protegem os seus lucros ao garantir que a sua balança
                            de veículos meça com precisão o peso dos veículos todos os dias. Essa tecnologia revolucionária reduz os seus custos operacionais por meio da minimização de erros, redução da
                            parada de produção e simplificação do serviço.</h3>
                            <h3>Principais características</h3>
                            <ul>
                                <li>Receptores superiores
                                e inferiores duráveis de
                                aço inoxidável.</li>  
                                <li>Construção robusta e
                                resistente à corrosão.</li>
                                <li>Monitora o desempenho,
                                detecta problemas e
                                simplifica o serviço.
                                </li>
                                <li>À prova de água mesmo
                                quando submerso.</li>
                                <li>Impede que os detritos
                                afetem a precisão da
                                pesagem.</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="cel-dimensao">
                    <div className="cel-dimensao-content">
                        <h2 className="cel-dimensao-title">Dimensões (mm)</h2>
                        <img className="cel-dimensao-img" src="/images/dim-pdx.png" alt="Dimensões Célula PDX"/>
                    </div>
                </div>



                <BottomBar/>
                <Footer/>
            </div>
        </div>
    )
}
export default ProdCelPDX;